import {NgModule} from '@angular/core';
import {BorrowerPhoneNumberVerificationComponent} from './borrower-phone-number-verification.component';
import {BorrowerPhoneNumberVerificationRoutingModule} from './borrower-phone-number-verification-routing.module';
import {DisplayPictureModule} from '../../views/common/display-picture/display-picture.module';
import {LoaderModule} from '../../directives/loader.module';
import {CommonModule} from '@angular/common';
import {
    MatButtonModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule
} from '@angular/material';
import {FormsModule} from '@angular/forms';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {ButtonModule} from '../../views/common/button/button.module';

@NgModule({
    declarations: [BorrowerPhoneNumberVerificationComponent],
    imports: [BorrowerPhoneNumberVerificationRoutingModule, DisplayPictureModule, LoaderModule, CommonModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonToggleModule, MatSelectModule, MatIconModule, CommonSectionsModule, ButtonModule]
})
export class BorrowerPhoneNumberVerificationModule {
}
